/* Theme ArtWeb v1.0.0 · © Studio Art Web · https://studioartweb.com.br · não editar sem falar com o Studio */
// HARMONY HEALTH | hh-popup.js | janela "Fique por dentro das novidades"
// (sections/hh-popup-novidades.liquid). Abre depois do atraso ou na intenção de saída
// (computador), no máximo uma vez a cada N dias, nunca para quem já assinou, nunca na
// sacola ou na conta, nunca com outra janela aberta e nunca sozinha no editor de temas.
// ?hh_popup=1 força a abertura para teste.

const CHAVE_VISTO = 'hh_novidades_visto'
const CHAVE_ASSINOU = 'hh_novidades'
const CHAVE_ENVIOU = 'hh_novidades_enviou'

const ler = (s, k) => { try { return s.getItem(k) } catch (e) { return null } }
const gravar = (s, k, v) => { try { s.setItem(k, v) } catch (e) {} }
const apagar = (s, k) => { try { s.removeItem(k) } catch (e) {} }
const local = (() => { try { return window.localStorage } catch (e) { return null } })()
const sessao = (() => { try { return window.sessionStorage } catch (e) { return null } })()
const L = { get: k => local && ler(local, k), set: (k, v) => local && gravar(local, k, v), del: k => local && apagar(local, k) }
const S = { get: k => sessao && ler(sessao, k), set: (k, v) => sessao && gravar(sessao, k, v), del: k => sessao && apagar(sessao, k) }

const jaAssinou = () => L.get(CHAVE_ASSINOU) === '1' || /(?:^|;\s*)hh_novidades=1/.test(document.cookie)
const marcarAssinou = () => {
  L.set(CHAVE_ASSINOU, '1')
  try { document.cookie = 'hh_novidades=1; path=/; max-age=31536000; SameSite=Lax' } catch (e) {}
}
const paginaBloqueada = () => /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkouts?|account)(?:\/|$)/i.test(location.pathname)
const outraJanelaAberta = d => [...document.querySelectorAll('dialog[open]')].some(x => x !== d) || document.documentElement.hasAttribute('scroll-lock')

function iniciar(d) {
  if (d.dataset.pronto) return
  d.dataset.pronto = '1'
  const forcar = new URLSearchParams(location.search).get('hh_popup') === '1'
  const editor = d.hasAttribute('data-editor')
  const estado = d.dataset.estado
  const atraso = Math.max(5, Number(d.dataset.atraso) || 12) * 1000
  const dias = Math.max(0, Number(d.dataset.dias) || 0)
  const form = document.getElementById(d.dataset.form)
  let voltaFoco = null

  const abrir = () => {
    if (d.open || outraJanelaAberta(d)) return false
    voltaFoco = document.activeElement
    try { d.showModal() } catch (e) { return false }
    L.set(CHAVE_VISTO, String(Date.now()))
    return true
  }
  const fechar = () => { if (d.open) d.close() }

  d.addEventListener('close', () => {
    if (voltaFoco && typeof voltaFoco.focus === 'function' && document.contains(voltaFoco)) voltaFoco.focus({ preventScroll: true })
    voltaFoco = null
  })
  // clique no fundo escuro: o alvo é o próprio dialog (a caixa interna cobre todo o resto)
  d.addEventListener('click', e => { if (e.target === d) fechar() })
  d.querySelectorAll('[data-hh-popup-fechar]').forEach(b => b.addEventListener('click', fechar))
  if (form) form.addEventListener('submit', () => S.set(CHAVE_ENVIOU, '1'))

  // editor de temas: só abre ao selecionar a seção
  if (editor) {
    const sec = d.closest('.shopify-section')
    document.addEventListener('shopify:section:select', e => { if (sec && e.target === sec) abrir() })
    document.addEventListener('shopify:section:deselect', e => { if (sec && e.target === sec) fechar() })
    return
  }

  const veioDaJanela = S.get(CHAVE_ENVIOU) === '1' || location.hash === '#' + d.dataset.form
  if (estado === 'ok') marcarAssinou()
  if (veioDaJanela && (estado === 'ok' || estado === 'erro')) {
    S.del(CHAVE_ENVIOU)
    abrir()
    return
  }

  if (forcar) { abrir(); return }
  if (jaAssinou() || paginaBloqueada() || estado === 'ok') return
  const visto = Number(L.get(CHAVE_VISTO)) || 0
  if (visto && Date.now() - visto < dias * 864e5) return

  let feito = false
  const tentar = () => {
    if (feito) return
    if (abrir()) { feito = true; limpar() }
  }
  let espera = setTimeout(function tenta() {
    tentar()
    if (!feito) espera = setTimeout(tenta, 4000) // outra janela aberta: tenta de novo depois
  }, atraso)

  // intenção de saída: só com mouse, quando o ponteiro sai pelo topo da janela
  const saida = e => { if (!e.relatedTarget && e.clientY <= 0) tentar() }
  const comMouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches
  let liberaSaida = null
  if (comMouse) liberaSaida = setTimeout(() => document.documentElement.addEventListener('mouseout', saida), 4000)
  function limpar() {
    clearTimeout(espera)
    clearTimeout(liberaSaida)
    document.documentElement.removeEventListener('mouseout', saida)
  }
}

document.querySelectorAll('dialog[data-hh-popup]').forEach(iniciar)
document.addEventListener('shopify:section:load', e => {
  const d = e.target.querySelector('dialog[data-hh-popup]')
  if (d) iniciar(d)
})
